import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-[100svh] w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0 h-full w-full overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Ultra%20minimal%20abstract%20composition%20of%20flowing%20liquid%20metal%20ribbons%20in%20silver%20and%20warm%20gold%20on%20a%20deep%20black%20background%2C%20elegant%20fine%20art%20photography%2C%20dramatic%20soft%20lighting%2C%20luxury%20brand%20aesthetic%2C%20cinematic%20depth%2C%20mostly%20dark%20tones%20with%20subtle%20golden%20light%20streaks%2C%20sophisticated%20and%20calm&width=1920&height=1080&seq=revra-hero-main&orientation=landscape"
          alt="REVRA Group コーポレートイメージ"
          className="hero-zoom h-full w-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/85" />

      <div className="relative z-10 flex min-h-[100svh] w-full flex-col items-center justify-center px-6 py-28 text-center">
        <p
          className="hero-anim font-label text-xs tracking-[0.5em] text-accent-300 md:text-sm"
          style={{ animationDelay: "0.15s" }}
        >
          REVRA GROUP
        </p>
        <h1
          className="hero-anim mt-8 font-display text-[32px] font-normal leading-[1.5] tracking-[0.06em] text-background-50 sm:text-4xl md:text-6xl md:font-light md:tracking-[0.08em] lg:text-7xl"
          style={{ animationDelay: "0.35s" }}
        >
          ヒトの可能性を、
          <br />
          価値に変える。
        </h1>
        <span className="hero-line mt-10 block h-px w-24 bg-accent-500 md:w-40" />
        <p
          className="hero-anim mt-8 font-label text-sm tracking-[0.4em] text-background-200 md:text-base"
          style={{ animationDelay: "0.75s" }}
        >
          CHALLENGE THE NEXT ERA.
        </p>
        <p
          className="hero-anim mt-8 max-w-2xl font-body text-[15px] leading-[1.9] text-background-100 md:text-base md:leading-[2.1]"
          style={{ animationDelay: "0.85s" }}
        >
          REVRA Groupは、営業支援・人材育成・イベントプロモーション・マーケティング・DX支援・飲食事業など、
          多角的な事業を展開するビジネスグループです。
        </p>
        <div
          className="hero-anim mt-10 flex flex-col items-center gap-4 sm:flex-row"
          style={{ animationDelay: "0.95s" }}
        >
          <a
            href="#service"
            className="w-56 whitespace-nowrap bg-background-50 px-10 py-3.5 text-center font-body text-[12px] tracking-[0.24em] text-foreground-950 transition-colors hover:bg-accent-500"
          >
            事業内容を見る
          </a>
          <Link
            to="/recruit"
            className="w-56 whitespace-nowrap border border-background-100/50 px-10 py-3.5 text-center font-body text-[12px] tracking-[0.24em] text-background-50 transition-colors hover:bg-background-50 hover:text-foreground-950"
          >
            採用情報
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 z-10 hidden -translate-x-1/2 flex-col items-center gap-3 md:flex">
        <span className="font-label text-[10px] tracking-[0.3em] text-background-300">SCROLL</span>
        <span className="block h-12 w-px bg-background-300/60" />
      </div>
    </section>
  );
}